import React, { Fragment, Component } from 'react'
import { connect } from 'react-redux'

import placeholderImage from '../../../../assets/images/placeholder-image.png'

class BkFlowConfirmationCta extends Component {
	constructor(props) {
		super(props)
		this.state = {
		}
	}

	renderConfirmationCtas() {
		const { configData, roomGroup, roomType, urlData } = this.props

		const hotelLabels = configData.hotel.labels[0]

		let confirmationCtaData = null,
				renderConfirmationCtas = [],
				brooklynCtaData = [
						{
							id: 'taste',
							image: 'https://www.1hotels.com/sites/default/files/styles/cards_3_constrained/public/2018-07/bb_osprey2-brooklyn-bridge.jpg?h=7f5fb1d3&itok=zVoDmC0e',
							title: 'Taste',
							description: 'Refuel at our unique outlets, handcrafted for you. From our lobby café, Neighbors to our lobby restaurant, The Osprey. From Brooklyn Heights Social Club, our 10th floor lounge to the 1 Rooftop Garden & Bar.',
							link: 'https://www.1hotels.com/brooklyn-bridge/taste',
							linkText: 'More Details'
						},
						{
							id: 'do',
							image: 'https://www.1hotels.com/sites/default/files/styles/cards_3_constrained/public/2018-07/170628_1hotelbb_relaxationpool_pm_306_hero.jpg?h=3a1090ef&itok=INxr7Vkd',
							title: 'Do',
							description: '1 Hotel Brooklyn Bridge is your destination in the city for sweeping skyline views, market-driven cuisine, seasonal dips in the rooftop plunge pool, fitness programming and holistic nature-inspired spa treatments at Bamford Haybarn Spa.',
							link: 'https://www.1hotels.com/brooklyn-bridge/do',
							linkText: 'More Details'
						},
						{
							id: 'gather',
							image: 'https://www.1hotels.com/sites/default/files/styles/cards_3_constrained/public/2018-07/brooklyn-bridge-meadowrue_prefunction_255_hero2.jpg?itok=vNi6Oi-a',
							title: 'Gather',
							description: 'We offer everything you need for your business function, wedding or social celebration, including unique meeting and event spaces, state-of-the-art technology, turnkey event planning and custom menu options. Did we mention the amazing views?',
							link: 'https://www.1hotels.com/brooklyn-bridge/gather',
							linkText: 'More Details'
						},
					],
					southBeachCtaData = [
						{
							id: 'taste',
							image: 'https://www.1hotels.com/sites/default/files/styles/cards_3_constrained/public/2018-07/south-beach-habitat-cf026366.jpg?itok=r7n6Q70P',
							title: 'Taste',
							description: 'You\'ll find farm-stand fresh food at seven unique dining outlets, including our newest signature restaurant, Habitat by Jose Mendin, Plnthouse by Matthew Kenney, Watr at the 1 Rooftop, Nativ Made, The Sandbox, our Lobby Bar, Drift and more.',
							link: 'https://www.1hotels.com/south-beach/taste',
							linkText: 'Explore Dining'
						},
						{
							id: 'do',
							image: 'https://www.1hotels.com/sites/default/files/styles/cards_3_constrained/public/2018-09/beach_v3.jpg?itok=rQtsZi5e',
							title: 'Do',
							description: 'Enjoy special programming and events happening around the hotel. Get out and explore the neighborhood on a bicycle tour, or take to the water with paddleboard yoga or kayaking through the mangroves. The Seedlings program at Basecamp offers daily adventures for younger guests.',
							link: 'https://www.1hotels.com/south-beach/do',
							linkText: 'Do More'
						},
						{
							id: 'gather',
							image: 'https://www.1hotels.com/sites/default/files/styles/cards_3_constrained/public/2018-07/south-beach-l42_meetings-terra_ballroom.jpg?itok=xP8ZhLrV',
							title: 'Gather',
							description: 'We offer everything you need for your business functions, wedding or celebrations, including unique meeting spaces, state-of-the-art technology, turnkey event planning, and menus by an experienced and innovative culinary team.',
							link: 'https://www.1hotels.com/south-beach/gather',
							linkText: 'View Our Spaces'
						},
					],
					centralParkCtaData = [
						{
							id: 'taste',
							image: 'https://www.1hotels.com/sites/default/files/styles/cards_3_constrained/public/2018-07/jams_1_hotel_central_park_photo_credit_eric_laignel.jpg?itok=p-aRnbcF',
							title: 'Taste',
							description: 'Farm-to-fork and handcrafted for you by critically-acclaimed Chef Jonathan Waxman. Chef Waxman brings the California cuisine movement to New York, at Jams and all of the hotel\'s food offerings.',
							link: 'https://www.1hotels.com/central-park/taste',
							linkText: 'Explore Dining'
						},
						{
							id: 'do',
							image: 'https://www.1hotels.com/sites/default/files/styles/cards_3_constrained/public/2018-07/1hcp-jan2016-79_0.jpg?itok=nLC3C9uQ',
							title: 'Do',
							description: 'Conveniently located in the heart of Manhattan, you can easily discover Central Park\'s wonders. Take bicycle tour, or travel on foot to explore Strawberry Fields and the Conservatory Water. Shopping, theater, restaurants and everything you could want during your visit to NYC is within reach at 1 Hotel Central Park!',
							link: 'https://www.1hotels.com/central-park/do',
							linkText: 'Do More'
						},
						{
							id: 'gather',
							image: 'https://www.1hotels.com/sites/default/files/styles/cards_3_constrained/public/2018-07/central-park-great_lawn_i_boardroom_2.jpg?itok=3Fa2sLwM',
							title: 'Gather',
							description: 'Everything you need for your business events, intimate wedding or special celebrations, including unique meeting and event spaces, state-of-the-art technology, turn-key planning and seasonal menus by Chef Jonathan Waxman.',
							link: 'https://www.1hotels.com/central-park/gather',
							linkText: 'View Our Spaces'
						},
					],
			westHollywoodCtaData = [
				{
					id: 'taste',
					image: 'https://www.1hotels.com/sites/default/files/styles/cards_3_constrained/public/2018-11/img_8668_web.jpg?itok=fXjIWakH',
					title: 'Taste',
					description: 'Savor the bounty of California with every bite and sip, from our signature restaurant and breathtaking rooftop bar by The h.wood Group to our all-day cafe by Chef Chris Crary, plus fresh takes on the classic lobby bar, pool bar, and in-room dining.',
					link: 'https://www.1hotels.com/west-hollywood/taste',
					linkText: 'More Details',
				},
				{
					id: 'do',
					image: 'https://www.1hotels.com/sites/default/files/styles/cards_3_constrained/public/2018-11/jeremy-bishop-225532-unsplash%20%281%29.jpg?h=cf3c5265&itok=hK7kBFDN',
					title: 'Do',
					description: 'Lounge poolside with skyline views. Hit The Field House for a workout. Stroll through West Hollywood, California’s most walkable city. And explore greater LA, from Downtown to the beaches and everything in between. We’ve got your #daylife covered.',
					link: 'https://www.1hotels.com/west-hollywood/do',
					linkText: 'More Details',
				},
				{
					id: 'gather',
					image: 'https://www.1hotels.com/sites/default/files/styles/cards_3_constrained/public/2018-11/Jeremy_room_CanyonPenthouse_balcony_1573%20%281%29.jpg?itok=4TfHxDtH',
					title: 'Gather',
					description: 'Meetings and events here are one-of-a-kind. We have everything you need, including more than 14,000 square feet of highly functional spaces, state-of-the-art technology, turnkey event planning, and custom menus by Executive Chef Chris Crary. Did we mention the views?',
					link: 'https://www.1hotels.com/west-hollywood/gather',
					linkText: 'More Details',
				},
			]

		if (urlData.hotelCode === '60507') {
			confirmationCtaData = southBeachCtaData
		} else if (urlData.hotelCode === '60735') {
			confirmationCtaData = centralParkCtaData
		} else if (urlData.hotelCode === '66266') {
			confirmationCtaData = brooklynCtaData
		} else if (urlData.hotelCode === '77961') {
			confirmationCtaData = westHollywoodCtaData
		}

		for (let ctaKey in confirmationCtaData) {
			renderConfirmationCtas.push(
				<div
					key={ confirmationCtaData[ctaKey].id + ' ' + roomType + ' ' + roomGroup }
					className="bk-flow-confirmation__cta"
				>
					{ confirmationCtaData[ctaKey].image ?
						<div className="bk-flow-confirmation__cta-image u-bg-image"
						     style={{ backgroundImage: 'url(' + confirmationCtaData[ctaKey].image + ')' }}>
							<img
								className="u-element-hidden"
								src={ confirmationCtaData[ctaKey].image }
								alt={ confirmationCtaData[ctaKey].title }
							/>
						</div>
					:
						<div className="bk-flow-confirmation__cta-image u-bg-image"
						     style={{backgroundImage: 'url(' + placeholderImage + ')'}}>
							<img
								className="u-element-hidden"
								src={ placeholderImage }
								alt={ confirmationCtaData[ctaKey].title }
							/>
						</div>
					}

					<div className="bk-flow-confirmation__cta-body center-xs">
						{ confirmationCtaData[ctaKey].title ?
							<h5>{ confirmationCtaData[ctaKey].title }</h5>
							:
							null
						}

						{ confirmationCtaData[ctaKey].description ?
							<p>{confirmationCtaData[ctaKey].description}</p>
						:
							null
						}
					</div>

					<div className="bk-flow-confirmation__cta-buttons">
						{ confirmationCtaData[ctaKey].link ?
							<button
								className="btn btn-primary"
								onClick={ () => window.open( confirmationCtaData[ctaKey].link )}
							>
								{ confirmationCtaData[ctaKey].linkText ? confirmationCtaData[ctaKey].linkText : hotelLabels.view }
							</button>
						:
							null
						}
					</div>
				</div>
			)
		}

		return renderConfirmationCtas
	}

	render() {
		const { urlData } = this.props

		return (
			<Fragment>
				{ urlData.hotelCode === '60735' ?
					<div className="bk-flow-confirmation__ctas-application">
						<div className="bk-flow-confirmation__ctas-application-content">
							<div
								className="bk-flow-confirmation__ctas-application-image"
								style={{backgroundImage: 'url(https://www.1hotels.com/sites/default/files/2018-12/CP-App-Image.jpg)'}}
				>
								<img
									className="u-element-hidden"
									src="https://www.1hotels.com/sites/default/files/2018-12/CP-App-Image.jpg"
									alt="1 Hotels Central Park App"
								/>
							</div>
							<div className="bk-flow-confirmation__ctas-application-data">
								<h4>Guide Your Stay with the 1 Hotels App</h4>
								<p>Download our app and have everything you need to guide your stay, right on your personal device. From 1-1 communication with our team, in-room dining orders, service requests and more - you’re just one touch away from whatever you need.</p>

								<div className="bk-flow-confirmation__ctas-application-buttons">
									<a className="btn btn-primary" href="https://itunes.apple.com/kw/app/1-hotels/id1405173522"
									   target="_blank" rel="noopener noreferrer">Download for iOS</a>
									<a className="btn btn-primary"
									   href="https://play.google.com/store/apps/details?id=com.runtriz.onehotels" target="_blank"
									   rel="noopener noreferrer">Download for Android</a>
								</div>
							</div>
						</div>
					</div>
				:
					null
				}
				<div className="bk-flow-confirmation__ctas">
					{ this.renderConfirmationCtas() }
				</div>
			</Fragment>
		)
	}
}

function mapStateToProps(state) {
	return {
		configData: state.configData.configuration,
		urlData: state.availabilityData.urlData
	}
}

export default connect(mapStateToProps, null)(BkFlowConfirmationCta)


// WEBPACK FOOTER //
// ./src/components/confirmation/elements/default/BkFlowConfirmationCta.js